import React, { useEffect, useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { LOGO_URL } from '../lib/constants';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 transition-colors ${scrolled ? 'bg-warm/95 shadow-sm backdrop-blur-md' : 'bg-warm'}`} data-id="element-67" data-mp="2rkb4x11r0cky">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 sm:px-8" data-id="element-68" data-mp="31bp2326890ax">
        <a href="#top" className="flex items-center" aria-label="Byronweb — inicio" data-id="element-69" data-mp="36bl9zci1pbvr">
          <img src={LOGO_URL} alt="Byronweb — Creación y diseño digital" className="h-12 w-auto sm:h-14" data-id="element-70" data-mp="3baen33tf70ve" />
        </a>

        <nav className="hidden items-center gap-7 md:flex" aria-label="Navegación principal" data-id="element-71" data-mp="3fayk87dzu4hj">
          <a href="#estilos" className="text-sm font-bold tracking-[-0.02em] text-ink transition-colors hover:text-brand-600" data-id="element-72" data-mp="2wl4gasn3kah9">
            Estilos
          </a>
          <a href="#como-funciona" className="text-sm font-bold tracking-[-0.02em] text-ink transition-colors hover:text-brand-600" data-id="element-73" data-mp="2ro49ugmc55pm">
            Cómo funciona
          </a>
        </nav>

        <CtaButton size="md" icon={<MessageCircleIcon className="h-4 w-4" data-id="element-75" data-mp="3fbcb8ngn7umd" />} data-id="element-74" data-mp="2hpohkabknqej">
          <span className="hidden sm:inline" data-id="element-76" data-mp="3fasw1eidnkc1">Hablemos</span>
          <span className="sm:hidden" data-id="element-77" data-mp="3abpptqqnv82h">WhatsApp</span>
        </CtaButton>
      </div>
    </header>;
}